import api from "./api";

export const getFeeConfigurations = () =>
  api.get("/usage-billing/fees/");

export const createFeeConfiguration = (data) =>
  api.post("/usage-billing/fees/", data);

export const updateFeeConfiguration = (id, data) =>
  api.patch(`/usage-billing/fees/${id}/`, data);

export const getUsageEvents = (params = {}) =>
  api.get("/usage-billing/events/", { params });

export const getMonthlyInvoices = (params = {}) =>
  api.get("/usage-billing/invoices/", { params });

export const updateInvoiceStatus = (id, data) =>
  api.patch(`/usage-billing/invoices/${id}/`, data);

export const generateInvoices = (billing_month) =>
  api.post("/usage-billing/generate-invoices/", { billing_month });

export const getUsageSummary = (params = {}) =>
  api.get("/usage-billing/summary/", { params });

export const getMyInvoices = (params = {}) =>
  api.get("/usage-billing/invoices/", { params });

export const getMyUsageSummary = (params = {}) =>
  api.get("/usage-billing/summary/", { params });
